import { Clock, CheckCircle2, Ban } from "lucide-react";

const SEV = {
  ok: "bg-[#EAF0FB] text-[#2B5FB3] border-[#CFE0F5]",
  warn: "bg-[#FCEFCC] text-[#8A5A00] border-[#F0DE9E]",
  late: "bg-[#FBEAEA] text-[#8A2526] border-[#F0C9C9]",
  done: "bg-[#E7F2EC] text-[#2F6F4E] border-[#BFE0CC]",
  cancelled: "bg-[#EEEDE8] text-[#68665E] border-[#DDDBD3]",
};

export function LifecycleBadge({ lifecycle, className = "" }) {
  if (!lifecycle) return null;
  const sev = lifecycle.severity || "ok";
  const cls = SEV[sev] || SEV.ok;
  const Icon = sev === "done" ? CheckCircle2 : sev === "cancelled" ? Ban : Clock;
  const text = lifecycle.done
    ? "Completed"
    : sev === "cancelled"
      ? "Cancelled"
      : `${lifecycle.days ?? 0}d · ${lifecycle.pending_label}`;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full border ${cls} ${className}`}
      title={lifecycle.reached_label ? `Reached: ${lifecycle.reached_label}` : ""}
      data-testid="lifecycle-badge"
    >
      <Icon className="w-3 h-3" /> {text}
    </span>
  );
}
